	var config = {

		/* Langauge */
		addToCartBtnText: 		'Add to Bag', //Add to Basket
		addedToCartBtnText: 	'Added to Bag', //Added to Basket
		addingToCartBtnText: 	'Adding', //Adding...
		soldOutBtnText: 		'Sold Out', //Sold Out
		//After adding a product to the cart, how long to wait before it returns to normal?
		returnBtnToNormal: 		4000, // milliseconds

		/* Selectors */
		cartCountSelector: 		'.header__icon-count',
		cartCountSelector2: 	'.title-quant',
		cartTotalSelector: 		'.mini-cart-total',
		cartRemoveSelector: 	'.cart-prod-remove',

		/* Icons*/
		successIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>',
		errorIcon: 				'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-times" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>',
		loadingIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sync" viewBox="0 0 512 512"><path d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"></path></svg>',


		/* No need to change this elements. */
		addToCartBtnSelector: 	'.btn-add-to-cart',
		addToCartFormSelector: 	'form[action="/cart/add"]',
		shopifyAjaxAddURL: 		'/cart/add.js',
		shopifyAjaxChangeURL: 	'/cart/change.js',
		shopifyAjaxCartURL: 	'/cart.js'
	}

//Provide the user Feedback if the Ajax was sucessful or not.
function ajaxFeedback(status, html, $addToCartForm) {
	$('.ajaxfeedback').remove();
	var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

	$addToCartForm.find(config.addToCartBtnSelector).after(feedback);
	$('.ajaxfeedback').slideDown();
}

//Update the button apperance during the various stages. Adding, added, and back to add.
function updateBtnText($button, label, icon) {
	if ($button.children().length) {
		$button.children().each(function () {
			if (icon) {
				if ($.trim($(this).text()) !== '') {
					$(this).html(label + icon);
				}
			} else {
				if ($.trim($(this).text()) !== '') {
					$(this).text(label);
				}
			}
		});
	} else {
		$button.val(label).text(label);
	}
}

//Format the money
function formatMoney(cents, format) {
	if (typeof cents == 'string') {
		cents = cents.replace('.', '');
	}
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) {
			return 0;
		}

		number = (number / 100.0).toFixed(precision);

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

// BG: Function to update the Cart Dropdown with the newly added product(s)
function updateMiniCartContents() {
    // ajax get request to cart.js
    $.ajax({
        type: 'GET',
        url: '/cart?view=compareprice',
        //url: '/cart.js',
        success: function (_data) {
            var data = JSON.parse(_data);
            _updateMiniCartContents(data);
        }
    });
}

function _updateMiniCartContents(data) {
			var currencySymbol = data.currency_symbol;

			var incentive = $(".canvas-cart__incentive").attr('data-threshold');
			var incentive_spend = incentive - data.total_price;
			var incentive_spend_money = formatMoney(incentive - data.total_price, currencySymbol + "\{\{amount\}\}");
			var incentive_percent = (data.total_price / incentive) * 100;
			if(incentive_spend > 0) {
				$(".canvas-cart__incentive-text span").text(incentive_spend_money);
				$(".canvas-cart__incentive-bar span").css("width", incentive_percent + "%");
				$(".canvas-cart__incentive-text--success").hide();
				$(".canvas-cart__incentive-text--failure").show();
			} else if(incentive_spend <= 0) {
				$(".canvas-cart__incentive-bar span").css("width", "100%");
				$(".canvas-cart__incentive-text--success").show();
				$(".canvas-cart__incentive-text--failure").hide();
			}
    		var cartTotalCost = formatMoney(data.total_price, currencySymbol + "\{\{amount\}\}"),
				cartCount = data.item_count;

				var cartTotalCost = (cartTotalCost.replace(/(<([^>]+)>)/ig,""));


			//Output cart total
			$(config.cartTotalSelector).text(cartTotalCost);
			$(config.cartCountSelector).html(cartCount);
			$('.klarna-enabled').remove();
			if (cartCount > 0) {
				$(config.cartCountSelector).removeClass('no-items');
				//$('.canvas-cart .canvas-cart__button--top').after('<p class="klarna-enabled"><i class="fa fas-check-circle"></i>Pay later available with <span class="klarna-logo">Klarna</span></p>');
			} else {
				$(config.cartCountSelector).addClass('no-items');
			}

          	if (data.total_price > 1000) {
				$('.cart-mini-actions .upsell').removeClass('under-thirty');
				$('.cart-mini-actions .upsell').addClass('over-thirty');
			} else {
				$('.cart-mini-actions .upsell').removeClass('over-thirty');
				$('.cart-mini-actions .upsell').addClass('under-thirty');
			}
          
			//Output cart total
			$(config.cartCountSelector2).html(cartCount);
			if (cartCount > 0) {
				$(config.cartCountSelector2).removeClass('no-items');
			} else {
				$(config.cartCountSelector2).addClass('no-items');
			}


			//remove all items within cart.
			$('.cart-mini-contents .cart-row .cart-item').remove();

			//image size filters
			String.prototype.imgURL = function(size) {
			  // remove any current image size then add the new image size
			  return this
			    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
			    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
			      return '_'+size+match;
			    })
			  ;
			};

			if (data.items.length>0) {
			$('.cart-mini-contents__empty').hide();
			}
			else {
			$('.cart-mini-contents__empty').show();
			}

			//with the returned data, focus soley on the items. For each item...
			$.each(data.items, function (i, item) {
              
              	var itemOption = item.options_with_values[0].name;
              	console.log(itemOption);
        		var priceAfterDiscount = item.price * 1;

				var itemTitle = item.product_title;
				var itemPrice = formatMoney(priceAfterDiscount, currencySymbol + "\{\{amount\}\}");                
				var itemFinalPrice = formatMoney(item.final_line_price, currencySymbol + "\{\{amount\}\}");
				var itemQuantity = item.quantity;
				var itemVariant = item.variant_title;
				var itemVariantId = item.variant_id;
				var itemProductId = item.product_id;
				var itemImage = item.image.imgURL('small');
				var itemUrl = item.url;
				var i = 0;
				var selectedqty=''
				if (i > 0){
				  selectedqty =  'selected'
				}

                var htmlPrice='';
                if (item.compare_at_price == null && item.price!=item.original_price ) {
                  item.compare_at_price=item.original_price;
                }
                if (item.compare_at_price != null) {
                  
                  htmlPrice='<span class="money cart-prod-price--now">'+itemPrice+'</span>';
                  htmlPrice+='<span class="money cart-prod-price--was">'+formatMoney(item.compare_at_price, currencySymbol + "\{\{amount\}\}")+'</span>';
                  
                } else {
                  htmlPrice='<span class="money">'+itemPrice+'</span>';
                }
         
				var minicartrow = '<div class="cart-item item-'+itemProductId+'"><div class="cart-img"><a href="' + itemUrl + '"><img src="' + itemImage + '" class="img-fluid"></a></div><div class="cart-details"><div><div class="product-title cart-prod-name"><a href="' + itemUrl + '">' + itemTitle + '</a></div><div class="cart-prod-variant product-size"><p class="product-size"><span>Size: UK</span>' + itemVariant + '</p></div></div></div><div class="cart-price"><p class="product-price">'+itemPrice+'</p></div><div class="cart-quantity"><div><p>Quantity:</p><select class="cart-product-quantity-select" data-variant-id="' + itemVariantId + '" data-variant-qty="" data-variant-price="" data-variant-subtotal="<span class=money>'+itemPrice+'</span>">';


         for (var ir = 1; ir <= 15; ir++) {
					 if(ir == itemQuantity){
					 	minicartrow += '<option value="'+ir+'" selected>'+ir+'</option>';
					 } else {
					 	minicartrow += '<option value="'+ir+'">'+ir+'</option>';
					 }
         }

				minicartrow += '</select></div></div><div class="cart-subtotal">'+itemFinalPrice+' </div><div class="cart-remove"> <ul> <li><a href="'+itemUrl+'"><img src="//cdn.shopify.com/s/files/1/0033/4476/0879/t/21/assets/icon-view.svg?129367" width="59px" alt=""><span class="text">View</span></a></li><li><div class="cart-prod-remove"> <span data-variant-id="' + itemVariantId + '"><img src="//cdn.shopify.com/s/files/1/0033/4476/0879/t/21/assets/icon-trash.svg?129365" width="59px" alt=""><span class="text">Remove</span></span></div></li></ul></div></div></div>';
				//add each product back to mini cart preview.
              	var itemPreorder="";
              if (item.available!=undefined) {
                itemPreorder='<div class="cart-prod-pre-order">Available: '+item.available+'</div>';
              }
              if (itemVariant == null) {
              	var itemSize = " "
              }
              else if (itemVariant == "Default Title") {
              	var itemSize = " "
              }
              else if (itemVariant.indexOf('Default') >= 0) {
              	var itemSize = " "
              }
              else {
              	if(itemOption == "Size") {
					function containsOnlyNumbers(str) {
  						return /^\d+$/.test(str);
					}
              		if(itemVariant.includes("/")) {
              			var size = itemVariant.split("/");
				    	var euPart1 = parseInt(size[0]) + 28;
				    	var euPart2 = parseInt(size[1]) + 28;
				    	var euSize = euPart1 + "/" + euPart2;
				    	var usPart1 = parseInt(size[0]) - 4;
				    	var usPart2 = parseInt(size[1]) - 4;
				    	var usSize = usPart1 + "/" + usPart2;
				    	var itemSize = '<div class="cart-prod-variant"><span>UK ' + itemVariant + ' | EU ' + euSize + ' | US '+ usSize +'</span></div>';
              		} else if(containsOnlyNumbers(itemVariant) == true){
	              		var ukSize = parseInt(itemVariant);
	              		var euSize = ukSize + 28;
	              		var usSize = ukSize - 4;
	              		var itemSize = '<div class="cart-prod-variant"><span>UK ' + ukSize + ' | EU ' + euSize + ' | US '+ usSize +'</span></div>';              			
              		} else {
              			var itemSize = '<div class="cart-prod-variant"><span>UK ' + itemVariant + '</span></div>';
              		}
              	} else if(itemOption == "Shoe Size") {
              		var ukSize = parseInt(itemVariant);
              		var euSize = ukSize + 33;
              		var usSize = ukSize + 2;
              		var itemSize = '<div class="cart-prod-variant"><span>UK ' + ukSize + ' | EU ' + euSize + ' | US '+ usSize +'</span></div>';
              	} else {
              		var itemSize = '<div class="cart-prod-variant"><span>UK ' + itemVariant + '</span></div>';
              	}
              	
              }

              var itemDiscount='';
              if (item.discounts.length > 0) {
                itemDiscount+="<ul class='discounts' role='list'>"
                item.discounts.forEach(x=> {
                   itemDiscount+="<li class='discounts__discount'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-discount' viewBox='0 0 12 12'><path fill-rule='evenodd' clip-rule='evenodd' d='M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z' fill='currentColor'></path></svg>"+x.title+"</li>";                    
                });
                itemDiscount+="</ul>";
              }
            
          
              
          
              	
				$('.canvas-cart .cart-mini-contents .cart-row').append('<div class="cart-item item-'+itemProductId+'"><div class="cart-item-left"><div class="cart-prod-img"><a href="' + itemUrl + '"><img src="' + itemImage + '" class="img-fluid"></a></div></div><div class="cart-item-right"><div class="cart-prod-name"><a href="' + itemUrl + '">' + itemTitle + '</a></div><div class="cart-prod-price">' + htmlPrice + '</div>'+itemPreorder+itemSize+itemDiscount+'<div class="cart-prod-quantity"><span class="label">Quantity: </span><span class="quantity-value">' + itemQuantity + '</span></div><div class="cart-prod-remove"><span data-variant-id="' + itemVariantId + '">Remove</span></div></div></div>');

				$('.cart-start .cart-mini-contents .cart-row').append(minicartrow);

			});

			//re-trigger the remove functionality.
			removeCartItemTrigger();
  }

//remove product by setting quantity to zero via the data attribute.
function removeItemFromCart(variant_id) {
	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity=0&id=' + variant_id,
		dataType: 'json',
		success: function (data) {

			//console.log('Remove Item Triggered');

			//Update the cart to reflect new contents.
			updateMiniCartContents();

		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log(response);

		}
	});
}

//BG: Function will trigger on the cart page if user changes variant
function addItem(variant_id,quantity,old_variant_id) {
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxAddURL,
		data: 'quantity='+quantity+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {
			ajaxFeedbackCart('success','Updated size','.product-title[data-variant-id='+old_variant_id+'] .cart-product-variant-select');
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}

//BG: function can be triggered by Quantity update, or variant update.
function quantityItemChange(variant_id,value,addProduct,new_variant_id,quantity) {

	//convert string to int
	var variant_id = parseInt(variant_id);

	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity='+value+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {

			if (addProduct == 'add') {
				addItem(new_variant_id,quantity,variant_id);
			} else {

				$.each(data.items, function(index,item) {
					if (variant_id === item.variant_id) {
						if (item.quantity == value) {
							ajaxFeedbackCart('success','Quantity updated','.product-title[data-variant-id='+variant_id+'] .cart-product-quantity select');

						//BG: if the amount has changed, but not to the value the user wanted.
						} else if (item.quantity < value) {
							ajaxFeedbackCart('warning','Quantity Updated to '+data.item_count+'. This is the last remaining amount.','.product-title[data-variant-id='+variant_id+'] .cart-product-quantity select');
						}
						return false
					}
				});
			}

			//Update Total Price
			var currencySymbol = data.currency_symbol;
			var cartTotalCost = formatMoney(data.total_price, currencySymbol + "\{\{amount\}\}");
			$('.cart-total-amount span').text(cartTotalCost);
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}




//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
	//Remove Item from Cart
	$(config.cartRemoveSelector + ' span').off().on("click", function () {
		var varientID = $(this).attr('data-variant-id');

		//Pass over to removeItemFromCart Function.
		removeItemFromCart(varientID);

	});
}

//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
	//Remove Item from Cart
	$(config.cartRemoveSelector + ' span').off().on("click", function () {
		var varientID = $(this).attr('data-variant-id');

		//Pass over to removeItemFromCart Function.
		removeItemFromCart(varientID);

	});
}

function addToCart(form) {
		//e.preventDefault();
		var $addToCartForm = form;
		var $addToCartBtn = $addToCartForm.find(config.addToCartBtnSelector+':first-of-type');

		//Adding button stage
		updateBtnText($addToCartBtn, config.addingToCartBtnText, config.loadingIcon);
		$addToCartBtn.addClass('btn-adding').prop('disabled', true);

		// Add to cart.
		$.ajax({
			url: config.shopifyAjaxAddURL,
			dataType: 'json',
			type: 'post',
			data: $addToCartForm.serialize(),
			success: function (itemData) {

				//Added button stage
				updateBtnText($addToCartBtn, config.addedToCartBtnText, config.successIcon);
				$addToCartBtn.removeClass('btn-adding').addClass('btn-added');

				//Once added, reset button back to add.
				window.setTimeout(function () {
					$addToCartBtn.prop('disabled', false).removeClass('btn-added');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}, config.returnBtnToNormal);

				updateMiniCartContents();
				dataOffcanvas.toggle();

				window.setTimeout(function () {
					$('.header-basket .cart-icon').addClass('swing animated');
					$('.header-basket').addClass('hover');
				}, 1000);

				window.setTimeout(function () {
					$('.header-basket').removeClass('hover');
					$('.header-basket .cart-icon').removeClass('swing animated');
				}, 4000);

			},
			error: function (XMLHttpRequest) {
				var response = eval('(' + XMLHttpRequest.responseText + ')');
				response = response.description;
				if (response.slice(0, 4) === 'All ') {
					ajaxFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
					$addToCartBtn.prop('disabled', false);
					updateBtnText($addToCartBtn, config.soldOutBtnText);
					$addToCartBtn.prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
				} else {
					ajaxFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
					$addToCartBtn.prop('disabled', false).removeClass('disabled');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}

			}

		});
		return false;
}

//BG: allows the user to update the quantity and/or variant on the cart page.
function cartItemQuantityVariant() {
	var cartItem = $('.cart-item');

	console.log(cartItem);

	cartItem.each(function(){
		var variantSelect = $(this).find('.cart-product-quantity-select'),
			variantSelectValueOriginal = '',
			quantitySelect = $(this).find('.cart-product-quantity-select'),
			quantitySelectId = quantitySelect.attr('data-variant-id'),
			quantitySelectValue = quantitySelect.val();

		variantSelect.on('focus', function(){
			variantSelectValueOriginal = $(this).val();
		});


		quantitySelect.on('change',function(){

			/* Update Cart */
				/* Get quantity amount */
				quantitySelectValue = $(this).val();

				/* Get variant ID */
				quantitySelectId = quantitySelect.attr('data-variant-id');

				/* Change Quantity*/
				quantityItemChange(quantitySelectId,quantitySelectValue);

			/* Update Front-end */
				/* Gets */
					/* Get Single Price */
					var quantityPrice = quantitySelect.attr('data-variant-price').replace(/[^0-9.]/g, "");

					/* Get Line Original Subtotal */
					var quantitySubtotalPrice = quantitySelect.attr('data-variant-subtotal').replace(/[^0-9.]/g, "");

					/* Get Line Original QTY */
					var quantityQuantity = quantitySelect.attr('data-variant-qty').replace(/[^0-9.]/g, "");

					/* Get Original Total */
					var summaryTotalPrice = $('.cart-summary .total').attr('data-subtotal');

					/* Get Original Quantity */
					var summaryTotalQty = $('.header-basket__count').text().replace(/[^0-9.]/g, "");

					/* Get Parent Cart Line Div */
					var parentDiv = $(this).parents('.cart-item');

					/* Get Line Subtotal Div */
					var parentDivFindSubtotal = $(parentDiv).find('.cart-subtotal');


				/* Calculate */
					/* Get Line New Subtotal + discount */
					var quantityNewTotalPrice = quantitySelectValue * quantityPrice *0.9;

					/* Get Price Difference */
					var quantityNewTotalDiff = quantityNewTotalPrice - quantitySubtotalPrice;

					/* Get New Subtotal */
					summaryNewTotalPrice = parseFloat(summaryTotalPrice) + parseFloat(quantityNewTotalDiff);

					/* Get QTY Difference */
					quantityDiff = parseFloat(quantitySelectValue) - parseFloat(quantityQuantity);

					/* Get QTY Change */
					quantityChange = parseFloat(summaryTotalQty) + parseFloat(quantityDiff);

					lineQtyChange = parseFloat(quantityQuantity) + parseFloat(quantityDiff);

					var originalCartQty = $('.header-basket__count').attr('data-original-qty');

					var newCartQty = parseFloat(originalCartQty) + parseFloat(quantityDiff);




				//	console.log('Original QTY:' + originalCartQty);


				//	console.log('summaryTotalQty:' + parseFloat(summaryTotalQty));
				//	console.log('qtyDiff:' + parseFloat(quantityDiff));

					totalQtyChanger = parseFloat(summaryTotalQty) + parseFloat(quantityDiff);

				//	console.log('Total Update: '+totalQtyChanger);
				/* Update */

					/* Update Line Subtotal */
					$(parentDivFindSubtotal).html(formatMoney(quantityNewTotalPrice.toFixed(2), "£\{\{amount\}\}"));

					/* Update Cart Subtotal */
					$('.cart-summary .total span span').html(formatMoney(summaryNewTotalPrice.toFixed(2), "£\{\{amount\}\}"));

					$(this).attr('data-variant-qty', lineQtyChange);
;

					/* Update Cart Qty */
					//$('.basket-icon .count').html(newCartQty);
					//$('.basket-icon .count').attr('data-original-qty', newCartQty);

					$('.toggle img').data('block', 'something');

					$('.title-quant').html(quantityChange);

							// Get Current Selected Qty
							console.log('Get Current Selected Qty: '+parseFloat(lineQtyChange));

							// Get Origional Selected QTY
							console.log('Get Original Selected Qty: ' + parseFloat(quantityQuantity));
							quantitySelect.attr('data-variant-qty',lineQtyChange)

							// Get Change Difference

							var ChangeDiff1 = parseFloat(lineQtyChange) - parseFloat(quantityQuantity);
							console.log('Get Change Diff: '+ChangeDiff1);

							// Get Current total
							console.log('Get Current Total: '+parseFloat(originalCartQty));

							// Calculate Increase / Decrease
							var newQtyVal = parseFloat(ChangeDiff1) + parseFloat(originalCartQty);
							console.log('GetNewQTYChangeTo: ' + newQtyVal);

							// Update Value
							$('.basket-icon .count').html(newQtyVal);
							$('.basket-icon .count').attr('data-original-qty', newQtyVal);

									//	console.log('Original Cart Qty: '+originalCartQty);
										//console.log('Qty Diff: '+quantityDiff);
										//console.log('New Cart Qty: '+newCartQty);


		})
	});
}

  
  function _updateCartContent() {
    	$.ajax({
		type: 'GET',
		url: '/cart?view=upsell',
		success: function (_data) {
          var data=JSON.parse(_data);
          $('[data-upsell]').replaceWith(data.upsell);
          if ($('[data-upsell] .cart-upsell__col').length==0) {
            $('[data-upsell]').remove();
          }
          else {
            initSwipers();
          }
          $('[data-cartitem]').remove();
        
          $(data.cartitems.replace(/\n/g,'')).each(function() {
            if ($('[data-cartitem]').length>0) {
              $('[data-cartitem]').last().after(this);  
            }
            else {
              $('[data-cartitems-header]').after(this);  
            }
          });
          
          var currencySymbol = data.currency_symbol;

          $('[data-freedelivery]').replaceWith(data.freedelivery);
          $('[data-total]').each(function() {
            var _t=$(this).data('total');
            var _tp=data.total_price;
            if (_t!='') _tp=_tp/parseInt(_t);
            $(this).html(formatMoney(_tp, currencySymbol + "\{\{amount\}\}"));
          });
          if (data.old_total_price!=data.total_price) {
            if ($('[data-total-was]').length==0) {
              $('[data-total=""]').addClass('cart-summary__total-now');
              $('[data-total=""]').after('<span data-total-was class="cart-summary__total-was"></span>');
            }
            $('[data-total-was]').html(formatMoney(data.old_total_price, currencySymbol + "\{\{amount\}\}"));
          }
          setUpsellTrigger();
          registerCartAjax();
          _updateMiniCartContents(data);
        }
        });
  }

  function setUpsellTrigger() {
    $(config.addToCartFormSelector).submit(function (e) {
    		e.preventDefault();
            _variantSelected=$(this).find('[name="id"]').val();
            var $addToCartForm=$(this);
            $.ajax({
			url: config.shopifyAjaxAddURL,
			dataType: 'json',
			type: 'post',
			data: $addToCartForm.serialize(),
			success: function (itemData) {
              console.log(itemData);
              _updateCartContent();
            }
            });
        });
  }

function UpdateItemInCart(variant_id,qty,updatecart) {
  $.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity='+qty+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {
          $('[data-cart-qty="'+variant_id+'"]').data('value',qty);
          if (updatecart===true) {
            _updateCartContent();
          }
          else {
			updateMiniCartContents();
          }
		},
		error: function (XMLHttpRequest) {
          $('[data-cart-qty="'+variant_id+'"]').val($('[data-cart-qty="'+variant_id+'"]').data('value'));          
			var response = eval('(' + XMLHttpRequest.responseText + ')');
            if (response.status == 422) {
              let product_name=response.message.split(/You can't add more (.*) to the cart/gi)[1]
              alert('Sorry there is not enough stock of '+product_name+' please reduce the quantity');
            }
            else {
              alert(response.message);
            }			
		}
	});
}
function registerCartAjax() {
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('change',function(e) {       
       UpdateItemInCart($(this).data('cart-qty'), parseInt($(this).val()));      
    });
    $('[data-cart-qty]').off('keypress').on('keypress', function(e) {
    if (e.keyCode === 13) {
      UpdateItemInCart($(this).data('cart-qty'), parseInt($(this).val()));      
      e.preventDefault();
    }
  });
    $('[data-cart-minus]').off('click').on('click',function() {
                let newQty= parseInt($(this).parent().find('[data-cart-qty]').val())-1;
                UpdateItemInCart($(this).parent().find('[data-cart-qty]').data('cart-qty'),newQty,true);                
        });
    $('[data-cart-plus]').off('click').on('click',function() {
                let newQty= parseInt($(this).parent().find('[data-cart-qty]').val())+1;
                UpdateItemInCart($(this).parent().find('[data-cart-qty]').data('cart-qty'),newQty,true);
    });
  }
}

  $(document).ready(function() {

    registerCartAjax();
    removeCartItemTrigger();
	if ($('body').hasClass('template-cart')) {
		cartItemQuantityVariant();
$.ajax({
		type: 'GET',
		url: '/cart?view=upsell',
		success: function (_data) {
          var data=JSON.parse(_data);
          console.log(data);
          $('[data-upsell]').replaceWith(data.upsell);      
          if ($('[data-upsell] .cart-upsell__col').length==0) {
            $('[data-upsell]').remove();
          }
          else {
            initSwipers();
          }
          setUpsellTrigger();          
        }
        });        
	}
    else  {
	

	$(config.addToCartFormSelector).submit(function (e) {
		e.preventDefault();
      if (_variantSelected!=undefined) {
        $('[data-validation]').hide();
		addToCart($(this));
      }
      else {
        $('[data-validation]').show();
      }
      	return false;
	});
    }
});
